<script setup lang="ts">
import { onMounted } from 'vue';
import { useRouter } from 'vue-router';

import { useAuthStore } from '@/stores/auth';

const router = useRouter();
const authStore = useAuthStore();

onMounted(async () => {
  try {
    // Load user data from token (this already calls fetchUserMemberships)
    await authStore.loadUserFromToken();

    // Redirect to the original destination or home
    const redirectPath = sessionStorage.getItem('authRedirect') || '/';
    sessionStorage.removeItem('authRedirect');

    router.push(redirectPath);
  } catch (error) {
    console.error('Authentication callback failed:', error);
    router.push('/auth/sign-in');
  }
});
</script>

<template>
  <div class="min-h-[100dvh] flex items-center justify-center bg-gray-50">
    <div class="text-center">
      <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary mx-auto" />
      <p class="mt-4 text-gray-600">Completing authentication...</p>
    </div>
  </div>
</template>
